// cb gets executed when the click was outside the target
const outsideClickFunc = (el, isActive, cb, button = false) => {
	const escapeKeyListener = e => {
		if (e.keyCode === 27) {
			window.removeEventListener('keyup', escapeKeyListener, false);
			cb();
		}
	};
	// Check if click is inside or outside targetEl
	const clickListener = e => {
		const dropdownEl = el;
		let targetEl = e.target;

		do {
			if (targetEl == dropdownEl || targetEl == button) {
				return;
			}

			targetEl = targetEl.parentNode;
		} while (targetEl);

		cb();
		document.removeEventListener('click', clickListener, false);
	};

	if (isActive) {
		window.removeEventListener('keyup', escapeKeyListener, false);
		document.removeEventListener('click', clickListener, false);
	} else {
		window.addEventListener('keyup', escapeKeyListener, false);
		document.addEventListener('click', clickListener, false);
	}
};

export { outsideClickFunc };
